import { IFormatObjectEditable } from "../IFormatObjectEditable";
import { IFormatSpecification } from "../IFormatSpecification";
import { IBoxLineObject } from "../objects";
import { AbstractTexturedShapeDrawableObjectEditor } from "./AbstractTexturedShapeDrawableObjectEditor";

export class BoxLineObjectEditor extends AbstractTexturedShapeDrawableObjectEditor<IBoxLineObject> {
  constructor(source: IBoxLineObject | BoxLineObjectEditor, specification?: IFormatSpecification, isNew: boolean = false) {
    super(source, specification, isNew);
  }

  getTypeName(): string {
    return "矩形";
  }

  clone(): IFormatObjectEditable {
    return new BoxLineObjectEditor(this);
  }
}
